import React from 'react';
import { get } from 'lib/comms';
import TextField from '@material/react-text-field';
import Table from 'components/Table/Table';
import PromoBannerItem from './PromoBannerItemPage';
import './PromoBanner.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faChevronRight, faMinusCircle } from '@fortawesome/free-solid-svg-icons';

export default class PromoBannerPage extends React.Component {
    columns = [
    {
        name: 'Banner',
        grow: 5,
        selector: 'name',
        sortable: true,
        wrap: true,
    },
    { name: 'Active', grow: 2, selector: 'active' },
    { name: 'Section Displayed', grow: 2, cell: (row) => {
        const rowCategoryIds = 
            new Set((row.categories || []).map(String));

            const names = this.state.categories
                .filter((category) => rowCategoryIds.has(String(category.id)))
                .map((category) => category.name);

            return names.join(', ');
        },
    },
    {
        name: '',
        selector: 'name',
        sortable: false,
        grow: 0,
        right: true,
        cell: () => <FontAwesomeIcon color="#999" icon={faChevronRight} />,
    },
];
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            files: [],
            editing: null,
            stepIndex: 0,
            categories: [],
        };
    }

    componentDidMount = () => {
        this.reload()
        this.fetchCategories();
    };

    fetchCategories = async () => {
        const categories = await this.allCategories();
        this.setState({ categories });
    }

    allCategories = async () => {
        const resp = await get('cms/knowledgebase_categories', null, true);
        const categories = [
                {
                    id: "1",
                    name: 'Main Feed',
                    icon_colour: null,
                    icon_name: null,
                },
                ...resp.categories,
            ];
        return categories ? categories : [];
    };

    reload = async () => {
        let resp = await get('cms/promo_banner', null, true);
        if (resp && resp.status === 401) this.setState({ logout: true });
        if (resp && resp.success) {
            this.setState({ data: resp.data });
        } else {
            if (resp && resp.status === 400) {
                this.setState({ data: [] });
            } else {
                console.log(resp);
            }
        }
    };


    // update item on change of any item params
    updatePromoBannerItem = (item) => {
        this.setState({
            ...item,
        });
    };

    doneEditing = () => {
        this.setState({ editing: null });
        this.reload();
    };

    render() {
        let { data, search, editing, files, isNew } = this.state;

        return (
            <>
                {this.state.editing ? (
                    <PromoBannerItem
                        promoBannerItem={editing}
                        onBack={this.doneEditing}
                        files={files}
                        updatePromoBannerItem={this.updatePromoBannerItem}
                    />
                ) : (
                    <div className="maincontainer">
                        <h4>Promotional Banner</h4>
                            <button
                                className={'btn btn-primary mb-4'}
                                disabled={editing}
                                style={{ float: 'right', right: '10px' }}
                                onClick={() => this.setState({ editing: { id: 'new' } })}
                            >
                                <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: '10px' }} />
                                ADD NEW BANNER
                            </button>
                        <Table
                            columns={this.columns}
                            data={data}
                            onRowClicked={(item) => this.setState({ editing: item })}
                            tableID="promoBanner"
                            defaultSortField={this.columns[0].selector}
                        />
                    </div>
                )}
            </>
        );
    }
}
